var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSozuLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 814,
    height: 526,
    viewBox: "0 0 814 526",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hard-light"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8366 255.03H160.995C182.992 255.03 193.831 244.192 193.831 222.195V137.716C193.831 115.72 182.992 104.881 160.995 104.881H86.0764V40.1673H107.755V84.4788H193.831V32.8351C193.831 10.8388 182.992 0 160.995 0H32.8366C10.8393 0 0 10.8388 0 32.8351V116.039C0 138.354 10.8393 149.193 32.8366 149.193H107.755V214.863H86.0764V169.595H0V222.195C0 244.192 10.8393 255.03 32.8366 255.03Z",
    fill: "white",
    fillOpacity: 0.55
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M239.559 255.03H367.718C389.715 255.03 400.554 244.192 400.554 222.195V32.8351C400.554 10.8388 389.715 0 367.718 0H239.559C217.562 0 206.723 10.8388 206.723 32.8351V222.195C206.723 244.192 217.562 255.03 239.559 255.03ZM292.799 214.863V40.1673H314.478V214.863H292.799Z",
    fill: "white",
    fillOpacity: 0.55
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M413.446 255.03H607.277V171.827H521.201V214.863H499.522V153.018L607.277 134.847V0H413.446V80.0158H499.522V40.1673H521.201V99.7806L413.446 117.952V255.03Z",
    fill: "white",
    fillOpacity: 0.55
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M653.005 255.03H781.163C803.161 255.03 814 244.192 814 222.195V0H727.924V214.863H706.245V0H620.169V222.195C620.169 244.192 631.008 255.03 653.005 255.03Z",
    fill: "white",
    fillOpacity: 0.55
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 526H86.0764V416.337H107.755V526H193.831V270.97H107.755V376.17H86.0764V270.97H0V526Z",
    fill: "white",
    fillOpacity: 0.55
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M206.723 303.805V526H292.799V434.508H314.478V526H400.554V303.805C400.554 281.808 389.715 270.97 367.718 270.97H239.559C217.562 270.97 206.723 281.808 206.723 303.805ZM292.799 394.341V311.137H314.478V394.341H292.799Z",
    fill: "white",
    fillOpacity: 0.55
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M446.282 526H574.441C596.438 526 607.277 515.161 607.277 493.165V270.97H521.201V485.833H499.522V270.97H413.446V493.165C413.446 515.161 424.285 526 446.282 526Z",
    fill: "white",
    fillOpacity: 0.55
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M653.005 526H781.163C803.161 526 814 515.161 814 493.165V408.686C814 386.69 803.161 375.851 781.163 375.851H706.245V311.137H727.924V355.448H814V303.805C814 281.808 803.161 270.97 781.163 270.97H653.005C631.008 270.97 620.169 281.808 620.169 303.805V387.008C620.169 409.324 631.008 420.162 653.005 420.162H727.924V485.833H706.245V440.565H620.169V493.165C620.169 515.161 631.008 526 653.005 526Z",
    fill: "white",
    fillOpacity: 0.55
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSozuLogo);
export default __webpack_public_path__ + "static/media/sozuLogo.fcc7eca30da7e21df865c000e7145a53.svg";
export { ForwardRef as ReactComponent };